import {
  DefaultError,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { useInfiniteHandler } from 'hooks';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';
import { apiClient } from 'utils';
import { getDefaultInfinitePageParam } from 'utils/service/defaultInfinitePageParam';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ICostResponse, IFinancesDetail, IIncomeResponse } from './types';

export const useGetInfiniteLabelBalance = (params?: IInfinitePageParams) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, infiniteHandler } = useInfiniteHandler();

  const { itemCount, page } = getDefaultInfinitePageParam(
    params?.page,
    params?.itemCount
  );

  return useInfiniteQuery<IFinancesDetail[], DefaultError>({
    queryKey: ['label-balance-infinite', params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: 'GET',
        url: `Settlement/Finance`,
        params: {
          ...JSON.parse(JSON.stringify(params ?? {})),
          itemCount,
          page: pageParam,
        },
      });

      const value = await responseHandler<
        IInfinitePageResponse<IFinancesDetail>
      >(response, {
        groupName: `useGetInfiniteLabelBalance - ${pageParam}`,
      });

      return infiniteHandler<IFinancesDetail>(value);
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
    enabled: true,
  });
};
export const useGetIncome = (id: string, enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IIncomeResponse, DefaultError>({
    queryKey: ['income', id],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Income/${id}`,
      });

      return responseHandler(response, {
        groupName: `usetGetIncome - ${id}`,
        notFoundPath: '/income',
      });
    },
    enabled: enabled,
  });
};

export const useGetCost = (id: string, enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ICostResponse, DefaultError>({
    queryKey: ['cost', id],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Cost/${id}`,
      });

      return responseHandler(response, {
        groupName: `usetGetCost - ${id}`,
        notFoundPath: '/cost',
      });
    },
    enabled: enabled,
  });
};
